import { Flex } from "antd"

import MobilePagination from "../../../../../Components/MobilePagination/MobilePagination"
import EmptyCases from "../EmptyCases"
import CaseCard from "./CaseCard"
import CaseCardSkeleton from "./CaseCardSkeleton"

import styles from "./styles.module.less"

const SKELETON_COUNT = 20

export const CaseLookupList = ({
  loading,
  data,
  totalCount,
  page,
  pageSize,
  onChangePage,
  onOpenCase
}) => {
  if (loading) {
    return (
      <div className={styles.grid}>
        {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
          <CaseCardSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (!data?.length) {
    return <EmptyCases />
  }

  return (
    <Flex vertical gap={16}>
      <div className={styles.grid}>
        {data.map((row) => (
          <CaseCard key={row.id} record={row} onOpen={onOpenCase} />
        ))}
      </div>
      {totalCount > pageSize && (
        <MobilePagination
          current={page}
          pageSize={pageSize}
          total={totalCount}
          onChange={onChangePage}
        />
      )}
    </Flex>
  )
}
